import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card, CardContent, TextField, IconButton, MenuItem, Select, Typography, Fab,
} from '@material-ui/core';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import CloseIcon from '@material-ui/icons/Close';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';

const useStyles = makeStyles((theme) => ({
  widget: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    width: 'fit-content', // 👉 la largeur suit le contenu
    maxWidth: 400, // 👉 limite max pour pas exploser
    minWidth: 200, // 👉 garde un minimum propre
    zIndex: 2000,
    boxShadow: theme.shadows[5],
    borderRadius: '12px',
  },
  inputRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  titleRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 2100,
  },
}));

const allowedVoiceNames = [
  'en-GB',
];

export default function PronunciationWidget() {
  const classes = useStyles();
  const [open, setOpen] = useState(true);
  const [word, setWord] = useState('');
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState('');
  const containerRef = useRef(null);

  useEffect(() => {
    const loadVoices = () => {
      const allVoices = speechSynthesis.getVoices();
      const filtered = allVoices.filter((v) => allowedVoiceNames.includes(v.lang));
      setVoices(filtered);
      if (filtered.length && !selectedVoice) {
        setSelectedVoice(filtered[0].name);
      }
    };
    loadVoices();
    speechSynthesis.onvoiceschanged = loadVoices;
  }, [selectedVoice]);

  const handleSpeak = () => {
    if (!word.trim()) return;
    const utterance = new SpeechSynthesisUtterance(word);
    const voice = voices.find((v) => v.name === selectedVoice);
    if (voice) utterance.voice = voice;
    speechSynthesis.speak(utterance);
  };

  if (!open) {
    return (
      <Fab
        color="primary"
        className={classes.fab}
        onClick={() => setOpen(true)}
      >
        <RecordVoiceOverIcon />
      </Fab>
    );
  }

  return (
    <Card className={classes.widget} ref={containerRef}>
      <CardContent>
        <div className={classes.titleRow}>
          <Typography variant="subtitle1">
            Pronunciation Box
          </Typography>
          <IconButton size="small" onClick={() => setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </div>

        <Select
          value={selectedVoice}
          onChange={(e) => setSelectedVoice(e.target.value)}
          fullWidth
          size="small"
          MenuProps={{
            container: containerRef.current,
            disablePortal: true,
          }}
        >
          {voices.map((voice, index) => (
            <MenuItem key={voice.name} value={voice.name}>
              {`voice ${index + 1}`}
              {' '}
              (
              {voice.lang}
              )
            </MenuItem>
          ))}
        </Select>

        <div className={classes.inputRow}>
          <TextField
            size="small"
            variant="outlined"
            placeholder="Word in English"
            value={word}
            onChange={(e) => setWord(e.target.value)}
            fullWidth
          />
          <IconButton color="primary" onClick={handleSpeak}>
            <VolumeUpIcon />
          </IconButton>
        </div>
      </CardContent>
    </Card>
  );
}
